module.exports = __webpack_public_path__ + "static/media/b3.916535f3.jpg";